import assetPath from '/app/packages/entity-pages/entity-pages-header/src/assets/free-cover.svg';
export default [globalThis.crate.assetsBaseUrl, assetPath].join('/')